export default __webpack_public_path__ + "static/media/business.6c0ac3f6.jpg";